module.exports = __webpack_public_path__ + "static/img/indexResercher.ab04b3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/indexResercher.png
// module id = 7j+W
// module chunks = 3